/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './Button.module.scss';

type Props = {
    title: string;
    className?: string;
    small?: boolean;
    onClick: () => void;
    disabled?: boolean;
};

export const Button: FC<Props> = ({ title, className, small, onClick, disabled }) => {
    return (
        <button
            className={classNames(styles.wrapper, className, {
                [styles.small]: small,
                [styles.disabled]: disabled,
            })}
            onClick={disabled ? () => {} : onClick}
        >
            {title}
        </button>
    );
};
